// extracted by mini-css-extract-plugin
export default {"logo":"MainProfileHeader_logo__n9IHU","content":"MainProfileHeader_content__xMOkG","mainTitle":"MainProfileHeader_mainTitle__5Ln7h","banner":"MainProfileHeader_banner__tMpIO"};